import axios from "axios";
import { useEffect } from "react";
import { useRef, useState } from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { IoEyeOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { countries, options, phoneREGEX, style, validationErrorMessage } from "../../../Utils/constants";
import { CustomDropdown } from "../../../Utils/dropdown";
import { getLocalStorage, updateTiersData } from "../../../Utils/localStorage";

const Tier1 = (props) => {
  const formRef = useRef(null);
  const navigate = useNavigate();

  const [refetch, setRefetch] = useState(false);

  const [reason, setReason] = useState([]);
  const [validation, setValidation] = useState({
    full_name: {
      error: false
    },
    phone: {
      error: false
    },
    country: {
      error: false
    },
    joining_reason: {
      error: false
    }
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    setRefetch(!refetch);
    props?.onUpdate(!refetch);

    const data = new FormData(formRef.current);
    const formData = Object.fromEntries(data.entries());

    let error = false;

    setValidation({
      full_name: {
        error: false
      },
      phone: {
        error: false
      },
      country: {
        error: false
      },
      joining_reason: {
        error: false
      }
    });

    /**
     * Validations
     */
    if (reason.length === 0) {
      setValidation((prevState) => ({
        ...prevState,
        joining_reason: {
          error: true
        }
      }));
      error = true;
    }
    if (formData.full_name.trim() === "") {
      setValidation((prevState) => ({
        ...prevState,
        full_name: {
          error: true
        }
      }));
      error = true;
    }
    if (formData.phone.trim() === "") {
      setValidation((prevState) => ({
        ...prevState,
        phone: {
          error: true
        }
      }));
      error = true;
    }
    if (!phoneREGEX.test(formData.phone.trim())) {
      error = true;
      setValidation((prevState) => ({
        ...prevState,
        phone: {
          error: true
        }
      }));
      toast.error(options.tier1.validationMessages.phoneInvalid, {
        toastId: "invalidPhone",
        hideProgressBar: true,
        style: options.dropdownStyle
      });
    }
    if (formData.country === "") {
      setValidation((prevState) => ({
        ...prevState,
        country: {
          error: true
        }
      }));
      error = true;
    }

    if (!error) {
      if (!e.currentTarget.className.includes("submit-now")) {
        toast.success("Successfully update Contact information.", {
          toastId: "updated1",
          hideProgressBar: true,
          style: options.dropdownStyle
        });
      }

      localStorage.setItem("tier1", true);

      localStorage.setItem(
        "t1",
        JSON.stringify({
          full_name: formData.full_name,
          country: formData.country,
          phone: formData.phone,
          joining_reason: reason
        })
      );

      // Send info to server
      if (e.currentTarget.className.includes("submit-now")) {
        props?.openModal();
      }
    }
  };

  useEffect(() => {
    if (getLocalStorage("t1")?.joining_reason) {
      setReason(getLocalStorage("t1")?.joining_reason);
    }
  }, []);

  return (
    <form autoComplete="off" ref={formRef} className="row">
      <div className="form-wrapper p-sm-5 p-4">
        <div className="row mb-4">
          <div className="col-12">
            <h1 className="font-pnsb mb-0 tier1">Contact information</h1>
            <small className="font-pnsb mb-4 tier2 text-light">
              Fields marked with * are mandatory
            </small>
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-12">
            <label htmlFor="full_name" className={validation.full_name.error ? "mb-0" : null}>
              Name *
            </label>
            {validationErrorMessage(validation.full_name.error)}
            <input
              type="text"
              autoComplete="chrome-off"
              id="full_name"
              name="full_name"
              className={validation.full_name.error ? "error" : null}
              defaultValue={
                getLocalStorage("t1") && getLocalStorage("t1").full_name
                  ? getLocalStorage("t1").full_name
                  : ""
              }
            />
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-12">
            <label htmlFor="phone" className={validation.phone.error ? "mb-0" : null}>
              Phone number *
            </label>
            {validationErrorMessage(validation.phone.error)}
            <input
              type="text"
              autoComplete="chrome-off"
              id="phone"
              name="phone"
              className={validation.phone.error ? "error" : null}
              defaultValue={
                getLocalStorage("t1") && getLocalStorage("t1").phone
                  ? getLocalStorage("t1").phone
                  : ""
              }
            />
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-12">
            <label htmlFor="country" className={validation.country.error ? "mb-0" : null}>
              Country *
            </label>
            {validationErrorMessage(validation.country.error)}
            <CustomDropdown
              className={validation.country.error ? "error-dropdown" : ""}
              options={countries}
              placeholder="Select country"
              name="country"
              defaultValue={
                getLocalStorage("t1") && getLocalStorage("t1").country
                  ? countries.filter((country) => country.value === getLocalStorage("t1").country)
                  : false
              }
              valueChanged={(e) => {
                setValidation((prevState) => ({
                  ...prevState,
                  country: { error: false }
                }));
              }}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <label className={validation.joining_reason.error ? "mb-0" : null}>
              Why join ZiXXar *
            </label>
            {validationErrorMessage(
              validation.joining_reason.error,
              "You must choose at least one option!"
            )}
            <div className="d-md-flex d-block">
              <label className="checkbox me-5 d-md-inline-block d-block" htmlFor="reason1">
                <input
                  type="checkbox"
                  id="reason1"
                  name="reason1"
                  value="Buy products at a discount"
                  onChange={(e) => {
                    if (!e.target.checked) {
                      setReason(reason.filter((r) => r !== e.target.value));
                    } else {
                      setReason((prevState) => [...prevState, e.target.value]);
                    }
                  }}
                  defaultChecked={
                    getLocalStorage("t1") &&
                    getLocalStorage("t1")?.joining_reason.includes("Buy products at a discount")
                      ? true
                      : false
                  }
                />
                <span className="text-light">Buy products at a discount</span>
              </label>
              <label className="checkbox d-md-inline-block d-block" htmlFor="reason2">
                <input
                  type="checkbox"
                  id="reason2"
                  name="reason2"
                  value="Work as a reseller"
                  onChange={(e) => {
                    if (!e.target.checked) {
                      setReason(reason.filter((r) => r !== e.target.value));
                    } else {
                      setReason((prevState) => [...prevState, e.target.value]);
                    }
                  }}
                  defaultChecked={
                    getLocalStorage("t1") &&
                    getLocalStorage("t1")?.joining_reason.includes("Work as a reseller")
                      ? true
                      : false
                  }
                />
                <span className="text-light">Work as a reseller</span>
              </label>
            </div>
            <label>
              <AiOutlineInfoCircle color="#FFE13F" fontSize="20px" className="me-2" />
              <small>You can select both of them</small>
            </label>
          </div>
        </div>

        {/* <div className="row mt-4">
          <div className="col-12 text-md-end">
            <button
              className="gradient alt d-inline-block save-form"
              onClick={(e) => {
                handleSubmit(e);
              }}>
              <span>Save form</span>
            </button>
          </div>
        </div> */}
      </div>

      <div className="d-flex align-items-center mt-4 justify-content-center flex-md-row flex-column-reverse">
        <button
          className="gradient alt small-height submit-now"
          disabled={getLocalStorage("tier1") !== null ? false : true}
          onClick={(e) => {
            handleSubmit(e);
          }}>
          <span>Submit form now</span>
        </button>
        <button
          className="gradient fill small-height ms-md-3 large-width mb-md-0 mb-3 btn-save"
          onClick={(e) => {
            e.preventDefault();
            handleSubmit(e);
            if (getLocalStorage("tier1") !== null) {
              props?.refTier2?.current?.scrollIntoView({
                alignToTop: true,
                block: "start",
                behavior: "smooth"
              });
            }
          }}>
          <span>Save and continue to About you</span>
        </button>
      </div>
    </form>
  );
};
export default Tier1;
